import { Component } from '@angular/core';
import { ApColumnBase } from './../ap-column-base';


import { ColumnFindControlDto } from 'webcommon/shared';

@Component({
  selector: 'ap-column-findcontrol',
  templateUrl: './ap-column-findcontrol.component.html',
  styleUrls: ['./ap-column-findcontrol.component.less']
})
export class ApColumnFindcontrolComponent extends ApColumnBase<ColumnFindControlDto> {

  override Id: string;
  findcontrolType: string;
  list: string[] = [];
  isDisable: boolean;
  isSingleSelect = true;

  constructor() {
   super();
  }

  load(): void {
    this.findcontrolType = this.columnInfoDto.FindControlType;
    this.list[0] = this.columnInfoDto.Callback(this.dataItem);
    this.isDisable = this.columnInfoDto.IsDisable(this.dataItem);
    this.isSingleSelect = this.columnInfoDto.SingleSelect;
  }

  onChange(event: any) {
    if (this.columnInfoDto.Change) {
      this.columnInfoDto.Change({dataItem: this.dataItem, Pk: event});
    }
  }

}
